var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMenuReports = function SvgMenuReports(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.953 13.5h-11.11l7.407 7.453c.14.094.375.188.563.188.14 0 .328-.047.468-.188 1.828-1.687 3.094-3.984 3.422-6.61.094-.421-.281-.843-.75-.843Zm-3.187 5.86L17.453 15h6.61c-.375 1.64-1.172 3.094-2.297 4.36ZM10.75 13.5V2.39c0-.421-.375-.75-.75-.75h-.094C4.281 2.439.016 7.313.25 13.173.438 19.125 5.547 24 11.5 24h.14c2.344 0 4.547-.75 6.329-2.063.375-.234.375-.796.047-1.125L10.75 13.5Zm.844 9H11.5c-5.11 0-9.61-4.266-9.75-9.375-.188-4.688 3-8.766 7.5-9.844v10.875l.422.422 6.656 6.656a9.307 9.307 0 0 1-4.734 1.266Zm12.61-12A11.203 11.203 0 0 0 13.75.047s0-.047-.047-.047C13.328 0 13 .375 13 .797V11.25h10.453c.422 0 .797-.328.75-.75ZM14.5 9.75V1.594c4.172.656 7.5 3.984 8.156 8.156H14.5Z",
    fill: "#7C5EE2"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMenuReports);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "5fb6ad027cfd192324eced7764f7ddfa.svg";